<div class="flex gap-x-2 mb-2">
  <div class="w-10/12" tuiGroup [collapsed]="true">
    <app-autocomplete
      label="Код"
      class="tui-group__inherit-item w-5/12 tui-group__auto-width-item"
      componentClass="tui-group__inherit-item"
      [labelOutside]="false"
      [formControl]="factPackageTypeForm.controls.packageTypeJson.controls.code"
      [items]="catalogs.packageTypes$ | async"
      [itemValue]="'code'"
      [itemText]="'code'"
      [itemSearch]="'search'"
    ></app-autocomplete>
    <tui-input
      [formControl]="factPackageTypeForm.controls.packageTypeJson.controls.name"
      class="w-auto"
      tuiTextfieldSize="m"
      [tuiTextfieldPostfix]="
        '(' +
        (
          factPackageTypeForm.controls.packageQuantityLimit.getRawValue() ?? 0
        ).toString() +
        ')'
      "
      >Описание</tui-input
    >
    @if (last) {
      <div class="tui-group__auto-width-item flex flex-col">
        <button
          appearance="custom-remove-package"
          tuiButton
          (click)="remove.emit()"
        >
          -
        </button>
        <button
          appearance="custom-create-package"
          tuiButton
          (click)="create.emit()"
        >
          +
        </button>
      </div>
    } @else {
      <button
        appearance="secondary-destructive"
        (click)="remove.emit()"
        class="tui-group__auto-width-item"
        tuiIconButton
        icon="tuiIconTrash"
        size="m"
      ></button>
    }
  </div>
  <tui-input-number
    [precision]="0"
    class="w-2/12"
    tuiTextfieldSize="m"
    [formControl]="factPackageTypeForm.controls.packageQuantity"
    >Кол-во упаковки</tui-input-number
  >
</div>
